import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { ElevatedButton } from '@producer/ui-kit';

import { useCurrentProject } from '../../hooks/use-current-project';
import { Header } from './project.page';
import { ListView, ListViewHeader, ListViewItem } from '../../components/list-view/list-view';
import { SortableHeaderCell } from '../../components/ordered-list/sortable-header-cell';
import { useOrderBy } from '../../components/ordered-list/use-order-by';
import { uiStore } from '../../core/stores/ui-store';
import { observer } from 'mobx-react-lite';
import { openModal } from '../../core/modal/open-modal';
import { CreateStoryboardModal } from '../../features/storyboards/components/create-storyboard.modal';

import styles from './project-storyboards.route.module.scss';
export const ProjectStoryboardsRoute = observer(() => {
  const project = useCurrentProject()!;
  const { orderBy, toggleOrder, sort } = useOrderBy();
  const navigate = useNavigate();

  useEffect(() => {
    uiStore.currentLocation = 'project.storyboards';

    return () => {
      uiStore.currentLocation = '';
    };
  }, []);

  const storyboards = sort(project.storyboards);

  const handleOpen = (storyboardId: string) => {
    const href = `./${storyboardId}`;
    navigate(href);
  };

  const handleCreateStoryboard = () => {
    openModal(CreateStoryboardModal, {
      projectId: project._id,
    });
  };

  return (
    <>
      <Header>
        <div>Storyboards</div>

        <ElevatedButton text="Create storyboard" onClick={handleCreateStoryboard} />
      </Header>

      <div className={styles['container']}>
        <ListView>
          <ListViewHeader>
            <SortableHeaderCell sortKey="name" orderBy={orderBy} onOrder={toggleOrder}>
              Name
            </SortableHeaderCell>
          </ListViewHeader>

          <tbody>
            {storyboards.map((storyboard, index) => (
              <ListViewItem onClick={() => handleOpen(storyboard._id)}>
                <td style={{ width: '100%' }}>{storyboard.name || `Storyboard ${index + 1}`}</td>
              </ListViewItem>
            ))}
          </tbody>
        </ListView>
      </div>
    </>
  );
});
